import { visit, Kind } from 'graphql/language'

/**
 * Converts @live directives in the query AST into *_liveKeys fields
 */
export default function convertLiveDirectives(query: any) {
  return visit(query, {
    [Kind.FIELD]: {
      enter(node, _, parent: any) {
        if ((node.directives || []).find((d) => d.name.value === 'live')) {
          if (
            parent.some(
              (n: Record<string, any>) =>
                n?.name?.value === `${node.name.value}_liveKeys`
            )
          ) {
            // prevent adding _liveKeys multiple times
            return
          }
          parent.push({
            kind: 'Field',
            name: {
              kind: 'Name',
              value: `${node.name.value}_liveKeys`,
            },
            arguments: node.arguments,
            directives: [],
            selectionSet: null,
          })
        }
      },
    },
    [Kind.DIRECTIVE]: {
      leave(node) {
        if (node.name.value === 'live') {
          return null
        }
      },
    },
  })
}
